import { layerTypes } from '@/data/layerTypes';
import type LayerType from '@/types/LayerType';

export function getLayerTypeById(id: number | string): LayerType | undefined {
    return layerTypes.find((layer: LayerType) => layer.id == id);
}

export function isLayerDraggable(type: string = 'Text'): boolean {
    return ['Text', 'Image', 'ImageSVG', 'CustomGraphicElement'].includes(type);
}

export function isGraduationLayer(type: string): boolean {
    return type === 'Graduation';
}

export function isPatternLayer(type: string): boolean {
    return type === 'BackPattern' || type === 'backPattern';
}

export function isThemeLayer(type: string): boolean {
    return type === 'Theme' || type === 'theme';
}
